import React from 'react';

function PopupRegistration({
  formData,
  errorMessage,
  onChange,
  onSubmit,
  onOpenConsent,
  onClose
}) {
  return (
    <div className="popup-registration" onClick={(event) => event.stopPropagation()}>
      <h2 className="popup-registration__heading">Еще немного формальностей</h2>
      <p className="popup-registration__heading">
        Заполните ваши данные, чтобы мы могли принимать у вас заказы
      </p>
      <form className="popup-registration__form" onSubmit={onSubmit}>
        <label>
          Фамилия
          <input
            type="text"
            name="surname"
            value={formData.surname}
            onChange={onChange}
            placeholder="Фамилия"
            required
          />
        </label>
        <label>
          Имя
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={onChange}
            placeholder="Имя"
            required
          />
        </label>
        <label>
          Отчество
          <input
            type="text"
            name="middleName"
            value={formData.middleName}
            onChange={onChange}
            placeholder="Отчество"
          />
        </label>
        <label>
          Дата рождения:
          <input
            type="date"
            name="birthday"
            value={formData.birthday}
            onChange={onChange}
            required
          />
        </label>
        <label>
          Электронная почта:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={onChange}
            placeholder="example@pochta.ru"
            required
          />
        </label>
        <div className="popup-registration__form-sex">
          <label>
            <input
              type="radio"
              name="sex"
              value="1"
              checked={formData.sex === '1'}
              onChange={onChange}
              required
            />
            Мужской
          </label>
          <label>
            <input
              type="radio"
              name="sex"
              value="2"
              checked={formData.sex === '2'}
              onChange={onChange}
              required
            />
            Женский
          </label>
        </div>
        <label>
          Номер телефона:
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={onChange}
            disabled
            placeholder="Телефон"
            required
          />
        </label>
        <div className="popup-registration__consent">
          <p className="popup-registration__consent-p">
            Нажимая на кнопку "Сохранить", вы даете
          </p>
          <button
            type="button"
            className="popup-registration__consent-button"
            onClick={onOpenConsent}
          >
            Согласие на обработку и хранение персональных данных
          </button>
        </div>
        <button className="popup-registration__button popup-registration__button_green" type="submit">
          Сохранить
        </button>
        {errorMessage && <p className="error">{errorMessage}</p>}
        <button className="popup-registration__button" type="button" onClick={onClose}>
          Отмена
        </button>
      </form>
    </div>
  );
}

export default PopupRegistration;
